import React from "react";

/**
 * 渲染普通商品询价页标题。
 */
export default function Title() {
  return (
    <>
      <h2>Request a Quote</h2>
      <p className="sub-title">
        Fill out the form below with the details of the specific parts you need.
        We will get back to you with the best prices.{" "}
        <em>Fields marked with * are mandatory.</em>
      </p>
    </>
  );
}
